module.exports = __webpack_public_path__ + "static/media/home-preview-read.d0e2e52c.jpg";